import React, { useState, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import userStore from "../../../zustand/userStore";
import {
  assignUser,
  clearAssignUser,
  fetchTeachers,
} from "./redux/teacherSlice";
import { createTeacherUser } from "../../../pages/user/redux/userThunk";

const AssignUser = () => {
  const { teacherData } = useSelector((state) => state.teachers); // get teacherData from redux
  const userData = userStore((state) => state.user);
  const masterData = useSelector((state) => state.masterData);

  const schoolId = masterData?.school_id;

  const [formData, setFormData] = useState({
    username: "",
    email: "",
    password: "",
    confirmPassword: "",
    role_id: "",
  });

  const [showPassword, setShowPassword] = useState(false);
  const [showConfirmPassword, setShowConfirmPassword] = useState(false);
  const dispatch = useDispatch();

  // 🔹 Auto-fill username from teacherData
  useEffect(() => {
    if (teacherData) {
      setFormData((prev) => ({
        ...prev,
        username: teacherData.name || "",
      }));
    }
  }, [teacherData]);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({ ...prev, [name]: value }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (formData.password !== formData.confirmPassword) {
      alert("Passwords do not match!");
      return;
    }

    // const body = {
    //   username: formData.username,
    //   email: formData.email,
    //   password: formData.password,
    //   role_id: formData.role_id,
    //   created_by: userData.id,
    //   teacherId: teacherData.teacher_id,
    // };

    const body = {
      username: teacherData.name || "",
      email: formData.email,
      password: formData.password,
      role_id: formData.role_id,
      created_by: userData.id,
      school_name: userData.school_name,
      contact_number: userData.contact_number,
      address: userData.address,
      school_type: "Primary",
      db_name: userData.db_name,
      port: userData.port,
      account_type: userData.account_type,
      teacher_id: teacherData.teacher_id,
    };

    console.log("srinu_61", body);
    try {
      await dispatch(createTeacherUser(body)).unwrap();
      dispatch(fetchTeachers(schoolId));
      dispatch(clearAssignUser());
    } catch (error) {
      console.error("User creation failed:", error);
    }
  };

  return (
    <div className="container mt-4">
      <div className="card shadow-sm mx-auto" style={{ maxWidth: "700px" }}>
        <div className="card-body">
          <form onSubmit={handleSubmit}>
            <div className="row g-4">
              {/* Username (readonly) */}
              <div className="col-md-6">
                <label className="form-label">Username</label>
                <input
                  type="text"
                  name="username"
                  className="form-control py-2 px-3"
                  value={formData.username}
                  readOnly
                  disabled
                />
              </div>

              {/* Email */}
              <div className="col-md-6">
                <label className="form-label">Email</label>
                <input
                  type="email"
                  name="email"
                  className="form-control py-2 px-3"
                  placeholder="Enter email"
                  value={formData.email}
                  onChange={handleChange}
                  required
                />
              </div>

              {/* Password */}
              <div className="col-md-6">
                <label className="form-label">Password</label>
                <div className="position-relative">
                  <input
                    type={showPassword ? "text" : "password"}
                    name="password"
                    className="form-control py-2 px-3 pe-5"
                    placeholder="Enter password"
                    value={formData.password}
                    onChange={handleChange}
                    required
                  />
                  <span
                    className="position-absolute top-50 end-0 translate-middle-y me-3"
                    style={{ cursor: "pointer" }}
                    onClick={() => setShowPassword((prev) => !prev)}
                  >
                    <i
                      className={`fa-solid ${
                        showPassword ? "fa-eye-slash" : "fa-eye"
                      }`}
                    ></i>
                  </span>
                </div>
              </div>

              {/* Confirm Password */}
              <div className="col-md-6">
                <label className="form-label">Confirm Password</label>
                <div className="position-relative">
                  <input
                    type={showConfirmPassword ? "text" : "password"}
                    name="confirmPassword"
                    className="form-control py-2 px-3 pe-5"
                    placeholder="Confirm password"
                    value={formData.confirmPassword}
                    onChange={handleChange}
                    required
                  />
                  <span
                    className="position-absolute top-50 end-0 translate-middle-y me-3"
                    style={{ cursor: "pointer" }}
                    onClick={() => setShowConfirmPassword((prev) => !prev)}
                  >
                    <i
                      className={`fa-solid ${
                        showConfirmPassword ? "fa-eye-slash" : "fa-eye"
                      }`}
                    ></i>
                  </span>
                </div>
              </div>

              {/* Role */}
              <div className="col-md-6">
                <label className="form-label">Role</label>
                <select
                  name="role_id"
                  className="form-select py-2 px-3"
                  value={formData.role_id}
                  onChange={handleChange}
                  required
                >
                  <option value="" disabled>
                    Select Role
                  </option>
                  <option value={2}>Admin</option>
                  <option value={1}>User</option>
                </select>
              </div>
            </div>

            {/* Submit Button */}
            <div className="text-center mt-5">
              <button type="submit" className="btn btn-primary px-5 py-2">
                Submit
              </button>
            </div>
          </form>
        </div>
      </div>
    </div>
  );
};

export default AssignUser;
